export const FetchError = () => {
  return <h2>Something went wrong! Please try again.</h2>;
};
